var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkflows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.1
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16ZM5.5 16V12.48M18.5 16V8.7C18.5 7.5799 18.5 7.01984 18.282 6.59202C18.0903 6.21569 17.7843 5.90973 17.408 5.71799C16.9802 5.5 16.4201 5.5 15.3 5.5H12M18.5 16C19.8807 16 21 17.1193 21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16ZM12 5.5L14.5 8M12 5.5L14.5 3",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27992 2.88C5.71656 2.88 6.07051 3.23395 6.07051 3.67059V5.44942H7.84933C8.28598 5.44942 8.63992 5.80336 8.63992 6.24C8.63992 6.67665 8.28598 7.03059 7.84933 7.03059H6.07051V8.80942C6.07051 9.24606 5.71656 9.6 5.27992 9.6C4.84328 9.6 4.48933 9.24606 4.48933 8.80942V7.03059H2.71051C2.27387 7.03059 1.91992 6.67665 1.91992 6.24C1.91992 5.80336 2.27387 5.44942 2.71051 5.44942H4.48933V3.67059C4.48933 3.23395 4.84328 2.88 5.27992 2.88Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkflows);
export default __webpack_public_path__ + "static/media/icon-workflows.1838d7739cac5f4147c26c8137241ad9.svg";
export { ForwardRef as ReactComponent };